import DashboardIcon from '@mui/icons-material/Dashboard';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import StorageIcon from '@mui/icons-material/Storage';
import AppsIcon from '@mui/icons-material/Apps';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Filter1Icon from '@mui/icons-material/Filter1';
import NumbersIcon from '@mui/icons-material/Numbers';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import InfoIcon from '@mui/icons-material/Info';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import GavelIcon from '@mui/icons-material/Gavel';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import AdjustIcon from '@mui/icons-material/Adjust';
import BuildIcon from '@mui/icons-material/Build';
import BuildCicrleIcon from '@mui/icons-material/BuildCircle';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import { ClientTypes, CustomerType } from '../../store/orgId_context';
import OutboxIcon from '@mui/icons-material/Outbox';
import PreviewIcon from '@mui/icons-material/Preview';
import ExtensionIcon from '@mui/icons-material/Extension';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


export const menuItems2 = [
  {
    itemName : "Dashboard",
    icon : <DashboardIcon/>,
    roles : ["all"],
    url : "/dashboard",
    uniqueId : "dashboard"
  },
  {
    itemName : "My Customers",
    icon : <SupervisorAccountIcon/>,
    roles : [ClientTypes.ISV, ClientTypes.AccService],
    url : "/clients",
    uniqueId : "administrationcustomers",
  },
  {
    itemName : "Invoice Flow Control",
    icon: <AppsIcon/>,
    roles : [ClientTypes.Company,ClientTypes.EndClient],
    notRoles : [CustomerType.AccCustomer],
    //basePath : "mycompany",
    uniqueId : "invoiceflow",
    children : [
      {
        itemName : "Issued",
        icon : <OutboxIcon/>,
        roles : ["all"],
        url : "/issued-invoices"
      },
      {
        itemName : "Received",
        icon : <MoveToInboxIcon/>,
        roles : ["all"],
        url : "/received-invoices"
      },
      {
        itemName : "E-Reporting",
        icon : <AssessmentIcon/>,
        roles : ["all"],
        countries : ["ME", "SI", "GB", "CA"],
        url : "/e-reporting"
      }
    ]
  },
  {
    itemName : "Settings",
    icon : <PersonIcon/>,
    roles : [ClientTypes.Company, ClientTypes.EndClient],
    uniqueId: "settings",
    //basePath : "mycompany",
    children : [
      {
        itemName : "Delivery channels",
        icon : <StorageIcon/>,
        roles : ["all"],
        notRoles : [CustomerType.AccCustomer],
        url : "/api-keys-and-credentials",
        uniqueId : "myprofile",
      },
      {
        itemName : "PDF customization",
        icon : <PreviewIcon/>,
        roles : ["all"],
        url : "/invoice-settings",
        uniqueId : "invoicesettings",
      },
    ]
  },
  {
    itemName : "Live/test mode",
    icon : <ToggleOffIcon/>,
    roles : [ClientTypes.Company, ClientTypes.EndClient],
    notRoles : [CustomerType.AccCustomer],
    url : "/operation-mode",
    //basePath : "mycompany",
    uniqueId : "operationmode"
  },
  {
    itemName : "Pre-made plugins",
    icon : <ExtensionIcon/>,
    roles : [ClientTypes.Company, ClientTypes.EndClient],
    notRoles : [CustomerType.AccCustomer],
    url : "/premade-plugins",
    uniqueId : "invoicesettings",
  },
  {
    itemName : "AI Extraction Studio",
    icon : <AutoAwesomeIcon/>,
    roles : [ClientTypes.Company, ClientTypes.EndClient],
    url : "/ai-extraction",
    uniqueId : "aiextraction",
    serverFlag : "docupathExtraction"
  },
  {
    itemName : "Dashboard",
    icon : <DashboardIcon/>,
    roles : [CustomerType.AccCustomer],
    url : "/dashboard",
    basePath : "mycompany",
    onlyForBasePath : true,
    uniqueId : "invoiceflow",
  },
  //mycompany
  {
    itemName : "Invoice Flow Control",
    icon: <AppsIcon/>,
    roles : [ClientTypes.Company,ClientTypes.EndClient, ClientTypes.ISV],
    notRoles : [CustomerType.AccCustomer],
    basePath : "mycompany",
    onlyForBasePath : true,
    uniqueId : "invoiceflow",
    children : [
      {
        itemName : "Issued",
        icon : <OutboxIcon/>,
        roles : ["all"],
        url : "/issued-invoices"
      },
      {
        itemName : "Received",
        icon : <MoveToInboxIcon/>,
        roles : ["all"],
        url : "/received-invoices"
      },
      {
        itemName : "E-Reporting",
        icon : <AssessmentIcon/>,
        roles : ["all"],
        countries : ["ME", "SI", "GB", "CA"],
        url : "/e-reporting"
      }
    ]
  },
  {
    itemName : "Settings",
    icon : <PersonIcon/>,
    roles : [ClientTypes.Company, ClientTypes.EndClient, ClientTypes.ISV],
    uniqueId: "settings",
    onlyForBasePath : true,
    basePath : "mycompany",
    children : [
      {
        itemName : "Delivery channels",
        icon : <StorageIcon/>,
        roles : ["all"],
        url : "/api-keys-and-credentials",
        uniqueId : "myprofile",
      },
      {
        itemName : "PDF customization",
        icon : <PreviewIcon/>,
        roles : ["all"],
        url : "/invoice-settings",
        uniqueId : "invoicesettings",
      },
      {
        itemName : "Pre-made plugins",
        icon : <ExtensionIcon/>,
        roles : ["all"],
        notRoles : [CustomerType.AccCustomer],
        url : "/premade-plugins",
        uniqueId : "invoicesettings",
      },
    ]
  },
  {
    itemName : "Live/test mode",
    icon : <ToggleOffIcon/>,
    roles : [ClientTypes.Company, ClientTypes.EndClient, ClientTypes.ISV],
    url : "/operation-mode",
    basePath : "mycompany",
    onlyForBasePath : true,
    uniqueId : "operationmode"
  },
  {
    itemName : "AI Extraction Studio",
    icon : <AutoAwesomeIcon/>,
    roles : [ClientTypes.Company, ClientTypes.EndClient, ClientTypes.ISV],
    url : "/ai-extraction",
    basePath : "mycompany",
    onlyForBasePath : true,
    uniqueId : "aiextraction",
    serverFlag : "docupathExtraction"
  },
  {
    itemName : "Integration",
    icon : <IntegrationInstructionsIcon/>,
    roles : ["integrator", ClientTypes.ISV],
    //basePath: "integration",
    uniqueId : "integration",
    children : [
      {
        itemName: "Public documentation",
        icon: <GavelIcon/>,
        url: "https://dddinvoices.com/documentation-e-invoicing",
        roles : ["all"]
      },
      {
        itemName: "Technical overview",
        icon: <GavelIcon/>,
        url: "/technical-overview",
        roles : ["all"]
      },
      {
        itemName: "DDDI_Save",
        icon: <GavelIcon/>,
        roles : ["all"],
        uniqueId : "dddisave",
        children : [
          {
            itemName: "API description",
            icon: <InfoIcon/>,
            url: "/technical-overview",
            roles : ["all"]
          },
          {
            itemName: "Step by step playground",
            icon: <LooksOneIcon/>,
            url: "/integration-wizard",
            roles : ["all"],
            uniqueId : "integrationWizard"
          },
          {
            itemName: "Steps",
            icon: <LooksTwoIcon/>,
            url: "/integration-wizard-step",
            roles : ["all"],
            uniqueId : "integrationSteps"
          },
          {
            itemName: "Return documents",
            icon: <Looks3Icon/>,
            url: "/integration-wizard-return",
            roles : ["all"],
            uniqueId : "integrationDocs"
          },
          {
            itemName: "All in One",
            icon: <NumbersIcon/>,
            url: "/integration-wizard-full",
            roles : ["all"]
          },
          {
            itemName: "Complexities & Keys",
            icon: <DynamicFeedIcon/>,
            url: "/about-complexities",
            roles : ["all"]
          },
          {
            itemName: "Sent invoices",
            icon: <ReceiptIcon/>,
            url: "/sent-integration-invoices",
            roles : ["all"]
          },
        ]
      },
      {
        itemName: "AddCustomer",
        icon: <GavelIcon/>,
        roles : [ClientTypes.ISV],
        uniqueId : "addcustomer",
        children : [
          {
            itemName: "API description",
            icon: <GavelIcon/>,
            url: "/technical-overview",
            roles : ["all"]
          },
          {
            itemName: "Example playground",
            icon: <GavelIcon/>,
            url: "/add-customer",
            roles : ["all"]
          },
          {
            itemName: "Update",
            icon: <GavelIcon/>,
            url: "/update-customer",
            roles : ["all"]
          },
        ]
      },
      {
        itemName: "Add user",
        icon: <GavelIcon/>,
        url: "/integration-add-user",
        roles : ["all"]
      },
      {
        itemName: "General playground",
        icon: <GavelIcon/>,
        url: "/api-playground",
        roles : ["all"]
      },
    ]
  },
  {
    itemName : "Maintainers",
    icon : <BusinessIcon/>,
    roles : ["maintainer"],
    uniqueId : "maintainers",
    children : [
      {
        itemName : "Themes creator",
        icon : <PermContactCalendarIcon/>,
        roles : ["all"],
        url : "/themes-creator"
      },
      {
        itemName : "Organization",
        icon : <PermContactCalendarIcon/>,
        roles : ["all"],
        url : "/maintainer-organization"
      },
    ]
  }
];
export const menuItemsOld =[
  {
    itemName : "Dashboard",
    icon : <DashboardIcon/>,
    roles : ["all"],
    url : "/dashboard",
    uniqueId : "dashboard"
  },
  {
    itemName : "Administration",
    icon : <PersonIcon/>,
    roles : ["transformer", "integrator", CustomerType.AccCustomer, CustomerType.ISVCustomer, ClientTypes.ISV, ClientTypes.AccService, "trustee"],
    basePath : "administration",
    uniqueId : "administration",
    children : [
      {
        itemName : "My company",
        icon : <BusinessIcon/>,
        roles : ["all"],
        url : "/my-profile",
        uniqueId : "mycompany",
        children : [
          {
            itemName : "Setup",
            icon : <PermContactCalendarIcon/>,
            roles : ["all"],
            url : "/client-init",
            uniqueId : "clientSetup"
          },
          {
            itemName : "Profile",
            icon : <PermContactCalendarIcon/>,
            roles : ["all"],
            url : "/my-profile",
            uniqueId : "myprofile",
          },
          {
            itemName : "Delivery channels",
            icon : <StorageIcon/>,
            roles : ["all"],
            url : "/api-keys-and-credentials",
            uniqueId : "apikeyandcreds",
          },
        ]
      },
      {
        itemName : "My Customers",
        icon : <SupervisorAccountIcon/>,
        roles : ["transformer", ClientTypes.AccService, ClientTypes.ISV],
        url : "/clients",
        uniqueId : "administrationcustomers",
      },
    ]
  },
  {
    itemName : "Invoice Flow Control",
    icon: <AppsIcon/>,
    roles : ["integrator", "transformer", ClientTypes.AccService, ClientTypes.ISV, "trustee"],
    basePath : "flow",
    uniqueId : "invoiceflow",
    children : [
      {
        itemName : "My company",
        icon : <BusinessIcon/>,
        roles : ["all"],
        url : "/issued-invoices"
      },
      {
        itemName : "My customers",
        icon : <SupervisorAccountIcon/>,
        roles : ["transformer", ClientTypes.AccService, ClientTypes.ISV],
        url : "/clients-flow"
      }
    ]
  },
  {
    itemName : "Integration",
    icon : <IntegrationInstructionsIcon/>,
    roles : ["transformer", "integrator", , ClientTypes.ISV],
    //basePath: "integration",
    uniqueId : "integration",
    children : [
      {
        itemName: "Public documentation",
        icon: <GavelIcon/>,
        url: "https://dddinvoices.com/documentation-e-invoicing",
        roles : ["all"]
      },
      {
        itemName: "Technical overview",
        icon: <GavelIcon/>,
        url: "/technical-overview",
        roles : ["all"]
      },
      {
        itemName: "DDDI_Save",
        icon: <GavelIcon/>,
        roles : ["all"],
        uniqueId : "dddisave",
        children : [
          {
            itemName: "API description",
            icon: <InfoIcon/>,
            url: "/technical-overview",
            roles : ["all"]
          },
          {
            itemName: "Step by step playground",
            icon: <LooksOneIcon/>,
            url: "/integration-wizard",
            roles : ["all"],
            uniqueId : "integrationWizard"
          },
          {
            itemName: "Steps",
            icon: <LooksTwoIcon/>,
            url: "/integration-wizard-step",
            roles : ["all"],
            uniqueId : "integrationSteps"
          },
          {
            itemName: "Return documents",
            icon: <Looks3Icon/>,
            url: "/integration-wizard-return",
            roles : ["all"],
            uniqueId : "integrationDocs"
          },
          {
            itemName: "All in One",
            icon: <NumbersIcon/>,
            url: "/integration-wizard-full",
            roles : ["all"]
          },
          {
            itemName: "Complexities & Keys",
            icon: <DynamicFeedIcon/>,
            url: "/about-complexities",
            roles : ["all"]
          },
          {
            itemName: "Sent invoices",
            icon: <ReceiptIcon/>,
            url: "/sent-integration-invoices",
            roles : ["all"]
          },
        ]
      },
      {
        itemName: "AddCustomer",
        icon: <GavelIcon/>,
        roles : [ClientTypes.ISV],
        uniqueId : "addcustomer",
        children : [
          {
            itemName: "API description",
            icon: <GavelIcon/>,
            url: "/technical-overview",
            roles : ["all"]
          },
          {
            itemName: "Example playground",
            icon: <GavelIcon/>,
            url: "/add-customer",
            roles : ["all"]
          },
          {
            itemName: "Update",
            icon: <GavelIcon/>,
            url: "/update-customer",
            roles : ["all"]
          },
        ]
      },
      {
        itemName: "Add user",
        icon: <GavelIcon/>,
        url: "/integration-add-user",
        roles : ["all"]
      },
      {
        itemName: "General playground",
        icon: <GavelIcon/>,
        url: "/api-playground",
        roles : ["all"]
      },
    ]
  },
  //Base path
  {
    itemName : "My company",
    icon : <BusinessIcon/>,
    roles : ["all"],
    basePath : "mycompany",
    uniqueId : "mycompany",
    onlyForBasePath : true,                 //This menu is not included, except it its basepath is specifically designated
    children : [
      {
        itemName : "Init",
        icon : <PermContactCalendarIcon/>,
        roles : ["all"],
        url : "/client-init"
      },
      {
        itemName : "Profile",
        icon : <PermContactCalendarIcon/>,
        roles : ["all"],
        url : "/my-profile"
      },
      {
        itemName : "Delivery channels",
        icon : <StorageIcon/>,
        roles : ["all"],
        url : "/api-keys-and-credentials"
      },
    ]
  },
  {
    itemName : "Maintainers",
    icon : <BusinessIcon/>,
    roles : ["maintainer"],
    uniqueId : "maintainers",
    children : [
      {
        itemName : "Themes creator",
        icon : <PermContactCalendarIcon/>,
        roles : ["all"],
        url : "/themes-creator"
      },
      {
        itemName : "Organization",
        icon : <PermContactCalendarIcon/>,
        roles : ["all"],
        url : "/maintainer-organization"
      },
    ]
  },
  {
    itemName : "Integration",
    icon : <IntegrationInstructionsIcon/>,
    roles : ["all"],
    basePath: "integration",
    uniqueId : "integration",
    onlyForBasePath : true,                 //This menu is not included, except it its basepath is specifically designated
    children : [
      {
        itemName: "Public documentation",
        icon: <GavelIcon/>,
        url: "https://dddinvoices.com/documentation-e-invoicing",
        roles : ["all"]
      },
      {
        itemName: "Technical overview",
        icon: <GavelIcon/>,
        url: "/technical-overview",
        roles : ["all"]
      },
      {
        itemName: "DDDI_Save",
        icon: <GavelIcon/>,
        roles : ["all"],
        uniqueId : "dddisave",
        children : [
          {
            itemName: "API description",
            icon: <InfoIcon/>,
            url: "/technical-overview",
            roles : ["all"]
          },
          {
            itemName: "Step by step playground",
            icon: <LooksOneIcon/>,
            url: "/integration-wizard",
            roles : ["all"],
            uniqueId : "integrationWizard"
          },
          {
            itemName: "Steps",
            icon: <LooksTwoIcon/>,
            url: "/integration-wizard-step",
            roles : ["all"],
            uniqueId : "integrationSteps"
          },
          {
            itemName: "Return documents",
            icon: <Looks3Icon/>,
            url: "/integration-wizard-return",
            roles : ["all"],
            uniqueId : "integrationDocs"
          },
          {
            itemName: "All in One",
            icon: <NumbersIcon/>,
            url: "/integration-wizard-full",
            roles : ["all"]
          },
          {
            itemName: "Complexities & Keys",
            icon: <DynamicFeedIcon/>,
            url: "/about-complexities",
            roles : ["all"]
          },
        ]
      },
      {
        itemName: "AddCustomer",
        icon: <GavelIcon/>,
        roles : ["all"],
        uniqueId : "addcustomer",
        children : [
          {
            itemName: "API description",
            icon: <GavelIcon/>,
            url: "/technical-overview",
            roles : ["all"]
          },
          {
            itemName: "Example playground",
            icon: <GavelIcon/>,
            url: "/add-customer",
            roles : ["all"]
          },
          {
            itemName: "Update",
            icon: <GavelIcon/>,
            url: "/update-customer",
            roles : ["all"]
          },
        ]
      },
      {
        itemName: "Add user",
        icon: <GavelIcon/>,
        url: "/integration-add-user",
        roles : ["all"]
      },
      {
        itemName: "General playground",
        icon: <GavelIcon/>,
        url: "/api-playground",
        roles : ["all"]
      },
    ]
  }
]

export const menuItems = [
  {
    itemName: "Dashboard",
    icon: (
      <svg
        width="25"
        viewBox="0 0 29 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.656522 0C0.482378 0 0.315335 0.0643423 0.19245 0.178961C0.0693364 0.293372 0 0.448896 0 0.610818V26.3892C0 26.5511 0.0693364 26.7066 0.19245 26.821C0.315335 26.9357 0.482378 27 0.656522 27H28.3442H28.344C28.7062 26.9998 29 26.7264 29 26.3892V0.610829C29 0.273568 28.7062 0.000240011 28.344 2.18461e-05H0.656293L0.656522 0ZM1.31257 1.22161H13.8506V9.147H1.31257V1.22161ZM15.1628 1.22161H27.688V18.0269H15.1628V1.22161ZM1.31257 10.3687H13.8506V25.7788H1.31257V10.3687ZM15.1628 19.2486H27.688V25.7788H15.1628V19.2486Z"
          fill="white"
        />
      </svg>
    ),
    url: "/dashboard",
    roles : ["all"]
  },
  {
    itemName: "My clients",
    icon: (
      <svg
        width="25"
        viewBox="0 0 31 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6753 5.97502C15.6753 9.10079 13.1412 11.6349 10.0154 11.6349C6.88956 11.6349 4.35553 9.10085 4.35553 5.97502C4.35553 2.84918 6.88956 0.315155 10.0154 0.315155C13.1412 0.315155 15.6753 2.84918 15.6753 5.97502Z"
          fill="white"
        />
        <path
          d="M15.3513 5.97501C15.3417 8.17925 13.946 10.2263 11.8605 10.9867C10.8016 11.3718 9.63698 11.4199 8.54923 11.1119C7.50326 10.8167 6.57597 10.1974 5.88296 9.3632C4.45193 7.64023 4.2883 5.11513 5.44339 3.20928C6.59527 1.3066 8.88616 0.292722 11.0712 0.741902C13.253 1.19109 14.947 2.97824 15.2904 5.17286C15.3353 5.43596 15.3513 5.70548 15.3513 5.97501C15.3546 6.38891 15.9962 6.3889 15.9931 5.975C15.9867 4.74292 15.6113 3.51724 14.8894 2.51621C14.1803 1.52797 13.1953 0.773995 12.053 0.353681C9.71401 -0.50619 6.98032 0.24138 5.40509 2.16647C4.62219 3.12585 4.14731 4.29051 4.05109 5.52582C3.95484 6.75466 4.25323 8.01244 4.89172 9.06481C5.50776 10.0819 6.43504 10.9193 7.5195 11.4103C8.67138 11.9301 9.95796 12.0809 11.1997 11.8338C13.6029 11.3589 15.5441 9.34395 15.913 6.92474C15.9612 6.6103 15.9901 6.29268 15.9901 5.97498C15.9965 5.56108 15.3548 5.56108 15.3515 5.97498L15.3513 5.97501Z"
          fill="white"
        />
        <path
          d="M27.0403 8.07659C27.0403 10.4103 25.1484 12.3022 22.8147 12.3022C20.4809 12.3022 18.5891 10.4103 18.5891 8.07659C18.5891 5.74286 20.4809 3.85098 22.8147 3.85098C25.1484 3.85098 27.0403 5.74286 27.0403 8.07659Z"
          fill="white"
        />
        <path
          d="M26.7192 8.07654C26.7096 9.68721 25.6925 11.1888 24.1653 11.7407C22.6092 12.3022 20.8605 11.8241 19.7984 10.5567C18.7492 9.30216 18.6273 7.45082 19.4712 6.05511C20.3054 4.67225 21.9738 3.92145 23.5652 4.24232C25.1695 4.56318 26.4112 5.86262 26.6743 7.47652C26.7096 7.67545 26.7192 7.87758 26.7192 8.07654C26.7224 8.49044 27.3641 8.49044 27.3609 8.07654C27.3513 6.17069 26.1449 4.45729 24.3577 3.79959C22.5898 3.15146 20.5139 3.71617 19.3204 5.17283C18.1108 6.64874 17.9279 8.776 18.9193 10.4188C19.9107 12.0615 21.8615 12.9054 23.7353 12.5268C25.5481 12.1642 27.0208 10.6337 27.3 8.8017C27.3353 8.56106 27.3577 8.31722 27.361 8.07337C27.3642 7.66268 26.7225 7.66264 26.7192 8.07654Z"
          fill="white"
        />
        <path
          d="M19.7117 20.0313V22.3446C19.7117 23.0794 19.1021 23.673 18.3673 23.673H1.66038C0.925657 23.673 0.332031 23.0794 0.332031 22.3446V20.0313C0.332031 16.4666 3.22289 13.5658 6.78752 13.5658H13.243C14.7125 13.5658 16.0729 14.0599 17.1606 14.8877C18.7039 16.0684 19.7114 17.9326 19.7114 20.031L19.7117 20.0313Z"
          fill="white"
        />
        <path
          d="M19.375 20.0312V22.1393C19.375 22.2355 19.3814 22.335 19.3717 22.4345C19.3493 22.704 19.2113 22.9574 19.0028 23.1307C18.807 23.2911 18.5664 23.3553 18.3161 23.3553C17.4081 23.3585 16.5001 23.3553 15.5921 23.3553H10.3815H5.02H1.84036H1.66069C1.16016 23.3489 0.72378 22.9831 0.656427 22.4793C0.617925 22.197 0.65001 21.8922 0.65001 21.6098V20.2976C0.65001 19.9093 0.653218 19.5243 0.710974 19.1393C0.804019 18.5297 0.983697 17.9265 1.25322 17.3714C1.78904 16.2741 2.6393 15.3468 3.69167 14.7308C4.6382 14.1757 5.71626 13.8965 6.81035 13.8965H8.43387H13.1087C14.2831 13.8965 15.4156 14.1757 16.4231 14.7917C17.6103 15.5137 18.5439 16.6495 19.0092 17.9617C19.2562 18.6259 19.3717 19.3222 19.375 20.0312C19.3782 20.4451 20.0199 20.4451 20.0167 20.0312C20.0103 18.4911 19.4873 17.0087 18.5312 15.8024C17.5654 14.5799 16.1537 13.7104 14.6264 13.3992C13.9013 13.2516 13.1793 13.2548 12.4478 13.2548H9.83283H7.34621C6.61148 13.2548 5.88309 13.274 5.16121 13.4505C2.57514 14.0794 0.521681 16.2869 0.101367 18.9243C-0.0366022 19.7874 0.00832166 20.6761 0.00832166 21.5488C0.00832166 21.8568 -0.0141381 22.1713 0.0147383 22.4793C0.0789118 23.1884 0.60191 23.8173 1.311 23.9584C1.59977 24.0162 1.90457 23.9969 2.19657 23.9969H3.79762H8.90557H14.5173H18.0627H18.3419C18.8039 23.9937 19.2595 23.814 19.5739 23.4675C19.9172 23.0921 20.0135 22.6397 20.0135 22.1488V20.859V20.0312C20.0167 19.6173 19.375 19.6173 19.375 20.0312Z"
          fill="white"
        />
        <path
          d="M30.0429 18.3439V20.5129C30.0429 20.9203 29.7317 21.2669 29.3338 21.2989H21.1874V19.8455C21.1874 17.5225 20.1126 15.4498 18.4345 14.099C18.9735 13.8776 19.5607 13.7589 20.1799 13.7589H25.4516C27.9863 13.7589 30.043 15.8091 30.043 18.3439L30.0429 18.3439Z"
          fill="white"
        />
        <path
          d="M29.722 18.3439C29.722 19.0626 29.7445 19.7877 29.722 20.5096C29.7124 20.792 29.5007 20.9684 29.2311 20.9684H28.5285H22.8557H21.1841L21.505 21.2893C21.505 20.5995 21.537 19.8968 21.4761 19.2101C21.3606 17.8754 20.9082 16.5727 20.1381 15.4722C19.721 14.8722 19.2237 14.3332 18.6557 13.8711C18.6076 14.0508 18.5627 14.2273 18.5146 14.407C19.06 14.1856 19.628 14.0765 20.2151 14.0765H20.8632H23.3819H25.3487C26.3177 14.0765 27.2449 14.3524 28.0246 14.9396C29.0931 15.7353 29.7155 17.0155 29.7219 18.3438C29.7252 18.7577 30.3668 18.7577 30.3637 18.3438C30.3573 17.0187 29.8214 15.7321 28.8653 14.8112C27.9509 13.9289 26.7188 13.4348 25.4482 13.4315C24.0108 13.4251 22.5702 13.4315 21.1327 13.4315H20.26C19.6055 13.4315 18.9606 13.5406 18.3509 13.7845C18.152 13.8647 18.0012 14.1502 18.2098 14.3203C19.1627 15.0936 19.9295 16.0978 20.3755 17.2465C20.6033 17.8336 20.7638 18.4528 20.8279 19.0817C20.8696 19.4732 20.8664 19.8646 20.8664 20.2592V21.2892C20.8664 21.4625 21.014 21.6101 21.1873 21.6101H22.5894H25.6118H28.4257H29.2022C29.6129 21.6101 29.9979 21.4368 30.2129 21.071C30.4279 20.7053 30.3637 20.2176 30.3637 19.8069V18.4368V18.347C30.3637 17.9298 29.7219 17.9298 29.7219 18.3437L29.722 18.3439Z"
          fill="white"
        />
      </svg>
    ),
    url: "/clients",
    roles : ["transformer"]
  },
  {
    itemName: "Profile",
    icon : (<i>i</i>),
    url : "/my-profile",
    roles : ["ISVCustomer", "AccCustomer"]
  },
  {
    itemName: "Services config",
    icon : (<i>i</i>),
    url : "/api-keys-and-credentials",
    roles : ["ISVCustomer", "ISVCustomer"]
  }
];

export const integrationItems = [
  {
    itemName: "Technical Overview",
    icon: (
      <svg
        width="25"
        viewBox="0 0 29 35"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.67198 7.79447C2.67198 7.56793 2.86056 7.38452 3.09318 7.38427H17.8025C18.0352 7.38427 18.2237 7.56793 18.2237 7.79447C18.2237 8.02102 18.0352 8.20468 17.8025 8.20468H3.09318C2.86056 8.20468 2.67198 8.02102 2.67198 7.79447ZM2.67198 11.6129C2.67198 11.3867 2.86056 11.203 3.09318 11.203H17.8025C18.0349 11.203 18.2235 11.3867 18.2235 11.6129C18.2235 11.8392 18.0349 12.0229 17.8025 12.0229H3.09318C2.86056 12.0229 2.67198 11.8395 2.67198 11.6129ZM2.67198 15.4314C2.67198 15.2049 2.86056 15.0212 3.09318 15.0212H17.8025C18.0352 15.0212 18.2237 15.2049 18.2237 15.4314C18.2237 15.658 18.0352 15.8416 17.8025 15.8416H3.09318C2.86056 15.8416 2.67198 15.658 2.67198 15.4314ZM0.843137 1.19667V25.8467C0.843137 26.0546 1.01566 26.2231 1.22911 26.2236H10.2539C9.88377 25.353 9.69103 24.4206 9.68611 23.4786H3.09346C2.86084 23.4786 2.67225 23.2947 2.67225 23.0681C2.67225 22.8416 2.86084 22.6579 3.09346 22.6579H9.72962C9.84593 21.5959 10.2026 20.5718 10.7733 19.6596H3.09399C2.98001 19.6631 2.86966 19.6212 2.7878 19.5441C2.70594 19.4669 2.65983 19.3604 2.65983 19.2494C2.65983 19.1384 2.70594 19.0322 2.7878 18.955C2.86966 18.8778 2.98001 18.8359 3.09399 18.8394H11.3721C11.5255 18.658 11.6892 18.482 11.8638 18.3114C12.916 17.2889 14.2574 16.5962 15.7168 16.3219C17.176 16.0475 18.6859 16.2041 20.0532 16.7717V7.1282H14.8055C14.4796 7.12795 14.1672 7.00181 13.9366 6.77728C13.706 6.55275 13.5765 6.24851 13.5763 5.93112V4.38564H3.09383C2.97985 4.38917 2.8695 4.34755 2.78764 4.2701C2.70578 4.1929 2.65967 4.08669 2.65967 3.97569C2.65967 3.86468 2.70578 3.75848 2.78764 3.68103C2.8695 3.60383 2.97985 3.56221 3.09383 3.56548H13.5763V0.820444H1.22971C1.01652 0.820696 0.843137 0.989296 0.843137 1.19667ZM14.4198 1.45298L19.4912 6.30782H14.8048C14.5913 6.30782 14.4183 6.1393 14.4183 5.93143V1.45298L14.4198 1.45298ZM23.7285 23.4377C23.7285 25.4367 22.7739 27.3221 21.1453 28.5387C19.5169 29.7557 17.3998 30.1656 15.4173 29.6483C13.4347 29.1308 11.8117 27.7448 11.0263 25.8979C10.2409 24.051 10.3823 21.9536 11.4086 20.2224C12.435 18.4913 14.2299 17.3235 16.2649 17.0626C18.3 16.8018 20.3438 17.4776 21.795 18.8914C23.0376 20.0942 23.7337 21.7315 23.7285 23.4377ZM23.1083 28.9417L22.5532 28.401C22.4996 28.4555 22.4454 28.5103 22.3908 28.5643C22.3361 28.6182 22.2789 28.6705 22.2232 28.7222L22.7786 29.2631L23.1083 28.9417ZM24.3746 28.8693L22.704 30.4964L23.1035 30.8854L24.7738 29.2587L24.3746 28.8693ZM28.156 32.7029C28.1568 32.607 28.1185 32.5151 28.0491 32.447L25.3701 29.8387L23.699 31.4659L26.3775 34.0742C26.5226 34.2147 26.7575 34.2147 26.9029 34.0742L28.0494 32.9584C28.1188 32.8908 28.1571 32.7985 28.156 32.7029ZM1.22879 27.0435H10.6681C11.7291 28.8407 13.5287 30.1104 15.6127 30.5325C17.697 30.9543 19.8669 30.4883 21.5753 29.2517L22.183 29.8435L22.0981 29.9262C21.7756 30.2413 21.7756 30.7512 22.0981 31.066L25.7827 34.6544C26.0104 34.8759 26.3192 35 26.6411 35C26.9631 35 27.2719 34.8759 27.4996 34.6544L28.6448 33.539C28.8723 33.317 29 33.0163 29 32.703C29 32.3894 28.8723 32.0887 28.6448 31.8667L24.9604 28.2785C24.6369 27.9642 24.1134 27.9642 23.7901 28.2785L23.7052 28.3613L23.0969 27.7707C24.361 26.1175 24.8431 24.0186 24.423 21.9983C24.0025 19.9781 22.7195 18.2275 20.8943 17.1839V6.67426C20.8945 6.56427 20.8492 6.45882 20.7689 6.38162L14.2246 0.116805C14.1456 0.0418757 14.0397 0 13.9293 0H1.22866C0.90304 0.000504523 0.590894 0.126893 0.360329 0.35117C0.130037 0.575448 0.000517258 0.879441 0 1.19656V25.8466C0.00051812 26.164 0.130037 26.4682 0.360329 26.6925C0.590622 26.9168 0.903152 27.043 1.22879 27.0435Z"
          fill="white"
        />
      </svg>
    ),
    url: "/technical-overview",
    roles : ["all"]
  },
  {
    itemName: "Add Customer API",
    icon: (
      <svg
        width="33"
        height="41"
        viewBox="0 0 33 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.98 7C3.89429 7 3 7.88888 3 8.968V31.272C3 32.3511 3.8943 33.24 4.98 33.24H24.78C27.8705 33.24 30.39 30.7358 30.39 27.664C30.39 24.8143 28.2211 22.4542 25.44 22.1277V14.216C25.44 14.042 25.3704 13.8752 25.2466 13.7522L18.6466 7.19219C18.5229 7.06916 18.355 7.00003 18.18 7L4.98 7ZM4.98 8.312H17.52V12.904C17.52 13.9831 18.4143 14.872 19.5 14.872H24.12V22.1277C21.3389 22.4542 19.17 24.8143 19.17 27.664C19.17 29.3724 19.9498 30.9039 21.1732 31.928H4.98C4.60768 31.928 4.32 31.6421 4.32 31.272V8.968C4.32 8.59793 4.60768 8.312 4.98 8.312ZM18.84 9.23963L23.1867 13.56H19.5C19.1277 13.56 18.84 13.2741 18.84 12.904V9.23963ZM8.61 13.56C8.52333 13.56 8.4375 13.577 8.35743 13.6099C8.27735 13.6429 8.2046 13.6912 8.14331 13.7521C8.08202 13.8131 8.03341 13.8854 8.00024 13.965C7.96707 14.0446 7.95 14.1299 7.95 14.216C7.95 14.39 8.01954 14.5568 8.14331 14.6799C8.26708 14.8029 8.43496 14.872 8.61 14.872H14.55C14.725 14.872 14.8929 14.8029 15.0167 14.6799C15.1405 14.5568 15.21 14.39 15.21 14.216C15.21 14.1299 15.1929 14.0446 15.1598 13.965C15.1266 13.8854 15.078 13.8131 15.0167 13.7521C14.9554 13.6912 14.8826 13.6429 14.8026 13.6099C14.7225 13.577 14.6367 13.56 14.55 13.56H8.61ZM8.61 17.496C8.52333 17.496 8.4375 17.513 8.35743 17.5459C8.27735 17.5789 8.2046 17.6272 8.14331 17.6881C8.08202 17.7491 8.03341 17.8214 8.00024 17.901C7.96707 17.9806 7.95 18.0659 7.95 18.152C7.95 18.326 8.01954 18.4928 8.14331 18.6159C8.26708 18.7389 8.43496 18.808 8.61 18.808H19.5C19.675 18.808 19.8429 18.7389 19.9667 18.6159C20.0905 18.4928 20.16 18.326 20.16 18.152C20.16 17.978 20.0905 17.8112 19.9667 17.6881C19.8429 17.5651 19.675 17.496 19.5 17.496H8.61ZM8.61 21.432C8.52333 21.432 8.4375 21.449 8.35743 21.4819C8.27735 21.5149 8.2046 21.5632 8.14331 21.6241C8.08202 21.6851 8.03341 21.7574 8.00024 21.837C7.96707 21.9166 7.95 22.0019 7.95 22.088C7.95 22.262 8.01954 22.4288 8.14331 22.5519C8.26708 22.6749 8.43496 22.744 8.61 22.744H18.18C18.355 22.744 18.5229 22.6749 18.6467 22.5519C18.7705 22.4288 18.84 22.262 18.84 22.088C18.84 22.0019 18.8229 21.9166 18.7898 21.837C18.7566 21.7574 18.708 21.6851 18.6467 21.6241C18.5854 21.5632 18.5126 21.5149 18.4326 21.4819C18.3525 21.449 18.2667 21.432 18.18 21.432H8.61ZM24.78 23.4C27.1571 23.4 29.07 25.3013 29.07 27.664C29.07 30.0267 27.1571 31.928 24.78 31.928C22.4029 31.928 20.49 30.0267 20.49 27.664C20.49 25.3013 22.4029 23.4 24.78 23.4ZM24.78 25.04C24.605 25.04 24.4371 25.1091 24.3133 25.2321C24.1895 25.3552 24.12 25.522 24.12 25.696V27.008H22.8C22.625 27.008 22.4571 27.0771 22.3333 27.2001C22.2095 27.3232 22.14 27.49 22.14 27.664C22.14 27.838 22.2095 28.0048 22.3333 28.1279C22.4571 28.2509 22.625 28.32 22.8 28.32H24.12V29.632C24.12 29.806 24.1895 29.9728 24.3133 30.0959C24.4371 30.2189 24.605 30.288 24.78 30.288C24.955 30.288 25.1229 30.2189 25.2467 30.0959C25.3705 29.9728 25.44 29.806 25.44 29.632V28.32H26.76C26.935 28.32 27.1029 28.2509 27.2267 28.1279C27.3505 28.0048 27.42 27.838 27.42 27.664C27.42 27.49 27.3505 27.3232 27.2267 27.2001C27.1029 27.0771 26.935 27.008 26.76 27.008H25.44V25.696C25.44 25.522 25.3705 25.3552 25.2467 25.2321C25.1229 25.1091 24.955 25.04 24.78 25.04ZM8.61 25.368C8.52333 25.368 8.4375 25.385 8.35743 25.4179C8.27735 25.4509 8.2046 25.4992 8.14331 25.5601C8.08202 25.6211 8.03341 25.6934 8.00024 25.773C7.96707 25.8526 7.95 25.9379 7.95 26.024C7.95 26.198 8.01954 26.3648 8.14331 26.4879C8.26708 26.6109 8.43496 26.68 8.61 26.68H16.86C16.9467 26.68 17.0325 26.663 17.1126 26.6301C17.1926 26.5971 17.2654 26.5488 17.3267 26.4879C17.388 26.427 17.4366 26.3546 17.4698 26.275C17.5029 26.1955 17.52 26.1101 17.52 26.024C17.52 25.9379 17.5029 25.8526 17.4698 25.773C17.4366 25.6934 17.388 25.6211 17.3267 25.5601C17.2654 25.4992 17.1926 25.4509 17.1126 25.4179C17.0325 25.385 16.9467 25.368 16.86 25.368H8.61Z"
          fill="white"
        />
      </svg>
    ),
    url: "/add-customer",
    roles : ["transformer"]
  },
  {
    itemName: "API Playground",
    icon: (
      <svg
        width="25"
        viewBox="0 0 36 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.23962 20.1298H31.9092C32.5414 20.1298 33.062 19.6146 33.062 18.989V1.14075C33.062 0.515175 32.5414 0 31.9092 0H4.23962C3.60742 0 3.08679 0.515195 3.08679 1.14075V18.989C3.04969 19.6146 3.57034 20.1298 4.23962 20.1298ZM3.94207 1.14069C3.94207 0.993595 4.09071 0.846248 4.23962 0.846248H31.9092C32.0579 0.846248 32.2068 0.993339 32.2068 1.14069V18.989C32.2068 19.136 32.0581 19.2834 31.9092 19.2834L4.23962 19.2831C4.09097 19.2831 3.94207 19.136 3.94207 18.9887V1.14069ZM35.4423 21.8962H0.557748C0.260193 21.8962 0 22.1539 0 22.4481C0 22.7425 0.260458 23 0.557748 23H35.4423C35.7398 23 36 22.7423 36 22.4481C36 22.1537 35.7769 21.8962 35.442 21.8962H35.4423ZM15.3595 11.7392L12.1982 9.82555L15.3595 7.91185V6.91817L11.0827 9.49415V10.1564L15.3595 12.7324V11.7392ZM20.2685 5.85102H19.3016L15.843 14.2415H16.8099L20.2685 5.85102ZM25.0288 9.49434L20.7521 6.91837V7.91205L23.9134 9.82575L20.7521 11.7394V12.7331L25.0288 10.1571V9.49434Z"
          fill="white"
        />
      </svg>
    ),
    url: "/api-playground",
    roles : ["transformer", "integrator"]
  },
  {
    itemName: "Invoice Object Description",
    icon: (
      <svg
        width="22"
        height="27"
        viewBox="0 0 22 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.625 1H5.97396C3.83854 1 3.10937 2.17187 3.10937 4.125C3.10937 4.95833 3.21354 5.84375 3.36979 6.70313C3.52604 7.61458 3.63021 8.47396 3.63021 9.46354C3.65625 11.7812 2.64062 12.9531 1 13.3958V13.474C2.64062 13.8646 3.65625 15.1146 3.63021 17.4323C3.63021 18.4219 3.52604 19.3333 3.36979 20.1927C3.21354 21.1042 3.10937 21.9375 3.10937 22.8229C3.10937 24.8542 3.94271 26 5.97396 26H6.625"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M14.5417 26H15.1927C17.224 26 18.0573 24.8802 18.0573 22.8229C18.0573 21.9375 17.9531 21.1042 17.7969 20.1927C17.6406 19.3073 17.5365 18.4219 17.5365 17.4323C17.5104 15.1146 18.5261 13.8646 20.1667 13.474V13.3958C18.5261 12.9531 17.5104 11.8073 17.5365 9.46354C17.5365 8.47396 17.6406 7.61458 17.7969 6.70313C17.9531 5.81771 18.0573 4.95833 18.0573 4.125C18.0573 2.17187 17.3281 1 15.1927 1H14.5417"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    ),
    url: "/invoice-object",
    roles : ["transformer", "integrator"]
  },
  {
    itemName: "Object Playground",
    icon: (
      <svg
        width="25"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.2978 3.46121H24.0851C24.5125 3.91902 24.5429 4.65174 24.1462 5.14021L24.1158 5.20132H27.26V19.915L1.74008 19.9147V5.20111H7.38742L7.17364 4.62106C7.05163 4.22415 7.11253 3.79679 7.35676 3.46101L0.702049 3.46122C0.305142 3.46122 0 3.76657 0 4.16327V22.8758C0 23.2727 0.30535 23.5779 0.702049 23.5779H28.2977C28.6946 23.5779 28.9998 23.2725 28.9998 22.8758L29 4.16327C29 3.76636 28.6947 3.46122 28.298 3.46122L28.2978 3.46121ZM14.4999 22.6317C14.0115 22.6317 13.6148 22.2348 13.6148 21.7465C13.6148 21.2581 14.0117 20.8614 14.4999 20.8614C14.9884 20.8614 15.3851 21.2583 15.3851 21.7465C15.3851 22.2043 14.9884 22.6317 14.4999 22.6317Z"
          fill="white"
        />
        <path
          d="M20.5136 27.8516V28.5232C20.5136 28.6758 20.3916 28.7979 20.2389 28.7979L8.76108 28.7981C8.6084 28.7981 8.48639 28.6761 8.48639 28.5234V27.8516C8.48639 27.6989 8.6084 27.5769 8.76108 27.5769H10.8063L11.3559 24.4938H17.6748L18.2242 27.5769H20.2695C20.3915 27.5769 20.5137 27.6991 20.5137 27.8516L20.5136 27.8516Z"
          fill="white"
        />
        <path
          d="M24.1158 6.42219L23.3831 6.33063C23.1084 6.30018 22.8641 6.11684 22.7419 5.84216C22.6503 5.56748 22.6808 5.2928 22.8335 5.04854L23.2913 4.46848C23.3524 4.37692 23.3524 4.2547 23.2608 4.16313L22.4977 3.39998C22.4061 3.30842 22.2839 3.30842 22.1923 3.36953L21.6123 3.82734C21.3985 4.01046 21.0934 4.04112 20.8186 3.9189C20.544 3.82734 20.3608 3.5831 20.3302 3.30843L20.2999 2.60638C20.2999 2.48437 20.1779 2.39259 20.0862 2.39259H18.9872C18.8652 2.39259 18.7734 2.48416 18.7734 2.60638L18.6819 3.33906C18.6514 3.61375 18.4681 3.85798 18.1934 3.94953C17.9187 4.07155 17.644 4.0411 17.3998 3.85797L16.8197 3.40017C16.7281 3.33905 16.6059 3.33905 16.5144 3.43061L15.7512 4.19377C15.6596 4.28533 15.6596 4.40756 15.7208 4.49912L16.1786 5.07917C16.3617 5.29296 16.3924 5.59809 16.2701 5.8728C16.1481 6.14749 15.9343 6.3306 15.629 6.36127L14.8963 6.45283C14.7743 6.45283 14.6825 6.57484 14.6825 6.66662V7.76556C14.6825 7.88757 14.7741 7.97935 14.8963 7.97935L15.629 8.07091C15.9037 8.10136 16.1479 8.2847 16.2701 8.55938C16.3921 8.83406 16.3312 9.10874 16.1786 9.353L15.721 9.90215C15.6599 9.99371 15.6599 10.1159 15.7514 10.2075L16.5146 10.9707C16.6061 11.0622 16.7284 11.0622 16.8199 11.0011L17.4 10.5433C17.6138 10.3602 17.9189 10.3295 18.1936 10.4517C18.4683 10.5433 18.6514 10.7875 18.6821 11.0929L18.7736 11.8256C18.7736 11.9476 18.8956 12.0394 18.9874 12.0394H20.0864C20.2084 12.0394 20.3002 11.9478 20.3002 11.8256L20.3917 11.0929C20.4222 10.8182 20.6055 10.574 20.8802 10.4517C21.1549 10.3297 21.4295 10.3602 21.6738 10.5433L22.2539 11.0011C22.3454 11.0622 22.4676 11.0622 22.5592 10.9707L23.3224 10.2075C23.4139 10.1159 23.4139 9.99371 23.3528 9.90215L22.895 9.3221C22.7119 9.10831 22.6812 8.80318 22.8034 8.52847C22.9255 8.25378 23.1392 8.07066 23.4446 8.04L24.1773 7.94844C24.2993 7.91799 24.3911 7.82643 24.3911 7.73465V6.63571C24.3295 6.5137 24.238 6.42213 24.1158 6.42213V6.42219ZM19.5063 9.29171C18.3463 9.29171 17.4 8.34545 17.4 7.18535C17.4 6.02524 18.3462 5.07899 19.5063 5.07899C20.6665 5.07899 21.6127 6.02524 21.6127 7.18535C21.6127 8.34518 20.6665 9.29171 19.5063 9.29171Z"
          fill="white"
        />
        <path
          d="M19.5063 5.93378C18.8042 5.93378 18.2546 6.48314 18.2546 7.18541C18.2546 7.88745 18.804 8.43703 19.5063 8.43703C20.2083 8.43703 20.7579 7.88767 20.7579 7.18541C20.7579 6.48314 20.2083 5.93378 19.5063 5.93378Z"
          fill="white"
        />
        <path
          d="M15.8431 11.5506L15.1104 11.459C14.8357 11.4286 14.5915 11.2453 14.4692 10.9706C14.3777 10.6959 14.4081 10.4212 14.5608 10.1769L15.0186 9.59689C15.0797 9.50533 15.0797 9.3831 14.9881 9.29154L14.225 8.52839C14.1334 8.43682 14.0112 8.43682 13.9196 8.49794L13.3396 8.95574C13.1258 9.13887 12.8207 9.16953 12.546 9.0473C12.2713 8.95574 12.0882 8.7115 12.0575 8.43683L11.9659 7.70415C11.9659 7.58214 11.8439 7.49036 11.7521 7.49036H10.6532C10.5312 7.49036 10.4394 7.58193 10.4394 7.70415L10.3479 8.43683C10.3174 8.71152 10.1341 8.95575 9.85939 9.0473C9.5847 9.16932 9.31002 9.13887 9.06576 8.95574L8.48571 8.49794C8.39414 8.43682 8.27192 8.43682 8.18036 8.52839L7.47875 9.32218C7.38718 9.41374 7.38718 9.53596 7.4483 9.62753L7.9061 10.2076C8.08923 10.4214 8.11989 10.7265 7.99766 11.0012C7.87565 11.2759 7.66186 11.459 7.3565 11.4897L6.62382 11.5812C6.50181 11.5812 6.41003 11.7032 6.41003 11.795V12.894C6.41003 13.016 6.5016 13.1078 6.62382 13.1078L7.3565 13.1993C7.63119 13.2298 7.87542 13.4131 7.99766 13.6878C8.11968 13.9625 8.05878 14.2371 7.9061 14.4814L7.47875 15.0306C7.41763 15.1221 7.41763 15.2443 7.50919 15.3359L8.27235 16.0991C8.36391 16.1906 8.48614 16.1906 8.5777 16.1295L9.15775 15.6717C9.37154 15.4886 9.67667 15.4579 9.95138 15.5801C10.2261 15.6717 10.4092 15.9159 10.4398 16.2213L10.5314 16.954C10.5314 17.076 10.6534 17.1678 10.7452 17.1678H11.8441C11.9662 17.1678 12.0579 17.0762 12.0579 16.954L12.1495 16.2213C12.1799 15.9466 12.3633 15.7024 12.638 15.5801C12.9126 15.4581 13.1873 15.4886 13.4316 15.6717L14.0116 16.1295C14.1032 16.1906 14.2254 16.1906 14.317 16.0991L15.0801 15.3359C15.1717 15.2443 15.1717 15.1221 15.1106 15.0306L14.6528 14.4505C14.4697 14.2367 14.439 13.9316 14.5612 13.6569C14.6832 13.3822 14.897 13.1991 15.2024 13.1684L15.9351 13.0768C16.0571 13.0464 16.1489 12.9548 16.1489 12.8631V11.7641C16.0567 11.6421 15.9651 11.5505 15.8431 11.5505L15.8431 11.5506ZM11.2641 14.4201C10.1041 14.4201 9.15778 13.4739 9.15778 12.3138C9.15778 11.1536 10.104 10.2074 11.2641 10.2074C12.4242 10.2074 13.3705 11.1536 13.3705 12.3138C13.3398 13.4738 12.4242 14.4201 11.2641 14.4201Z"
          fill="white"
        />
        <path
          d="M11.2641 11.0622C10.5621 11.0622 10.0125 11.6115 10.0125 12.3138C10.0125 13.0159 10.5619 13.5654 11.2641 13.5654C11.9662 13.5654 12.5158 13.0161 12.5158 12.3138C12.5158 11.6118 11.9662 11.0622 11.2641 11.0622Z"
          fill="white"
        />
        <path
          d="M14.9273 4.46857L14.4695 4.16322C14.2864 4.04121 14.1948 3.85788 14.2253 3.64431C14.2253 3.43052 14.3473 3.2474 14.5611 3.15584L15.0496 2.9116C15.1107 2.88115 15.1716 2.78959 15.1411 2.69781L14.8664 1.93466C14.8053 1.90421 14.7138 1.84331 14.6527 1.87376L14.1337 1.99577C13.9199 2.05688 13.7368 1.96532 13.5844 1.81265C13.4317 1.65997 13.4012 1.4464 13.4624 1.23259L13.6455 0.713676C13.6759 0.622114 13.6455 0.530552 13.5539 0.499889L12.8212 0.13364C12.7601 0.103191 12.6686 0.13364 12.6075 0.194753L12.3021 0.652558C12.1801 0.835683 11.9968 0.927245 11.7832 0.896795C11.5694 0.896795 11.3863 0.774783 11.2947 0.591446L11.0505 0.102978C11.02 0.0114154 10.9285 -0.0190345 10.8367 0.0114154L10.0735 0.286102C9.98197 0.316552 9.95153 0.408114 9.95153 0.469227L10.0735 0.988145C10.104 1.20193 10.0431 1.38505 9.89041 1.53751C9.73774 1.69018 9.52416 1.72063 9.31036 1.65952L8.79144 1.4764C8.69988 1.44595 8.63877 1.4764 8.57765 1.56796L8.24186 2.27001C8.21141 2.36157 8.24186 2.42268 8.30297 2.48379L8.76077 2.78914C8.9439 2.91115 9.03546 3.09449 9.00501 3.30806C9.00501 3.52185 8.883 3.70497 8.69966 3.79653L8.21119 4.04077C8.11963 4.07122 8.08918 4.16278 8.11963 4.25455L8.36387 5.01771C8.39432 5.10927 8.48588 5.13972 8.54699 5.13972L9.09636 5.01771C9.31014 4.9566 9.49326 5.04816 9.64572 5.20083C9.79839 5.35351 9.82884 5.56708 9.76773 5.78088L9.58461 6.2998C9.55416 6.39137 9.58461 6.48293 9.67617 6.51359L10.4089 6.87984C10.47 6.91029 10.592 6.87984 10.6226 6.81873L10.928 6.36092C11.05 6.1778 11.2333 6.08623 11.4469 6.11668C11.6607 6.11668 11.8438 6.2387 11.9354 6.42203L12.1796 6.9105C12.2101 7.00206 12.3016 7.03251 12.3934 7.00206L13.1566 6.72738C13.2481 6.69693 13.2786 6.60536 13.2786 6.54425L13.1566 6.02533C13.0954 5.81155 13.187 5.62843 13.3397 5.47597C13.4924 5.3233 13.7059 5.29285 13.9197 5.35396L14.4386 5.53708C14.5302 5.56753 14.5913 5.53708 14.6524 5.44552L14.9882 4.74347C15.0189 4.62104 14.9885 4.52947 14.9273 4.46857ZM10.9589 4.89593C10.1957 4.52968 9.89035 3.61383 10.2568 2.85067C10.6231 2.08752 11.5389 1.78215 12.3021 2.14863C13.0652 2.51488 13.3706 3.43073 13.0041 4.19388C12.6379 4.9264 11.722 5.26219 10.9589 4.89593Z"
          fill="white"
        />
        <path
          d="M12.0579 2.66736C11.6001 2.45358 11.0505 2.63691 10.8369 3.09472C10.6231 3.55253 10.8065 4.10208 11.2643 4.31566C11.7221 4.52945 12.2716 4.34611 12.4852 3.8883C12.699 3.46116 12.5159 2.91157 12.0579 2.66736Z"
          fill="white"
        />
      </svg>
    ),
    url: "/object-playground",
    roles : ["transformer", "integrator"]
  },
  // {
  //   itemName: "Finish",
  //   icon: (
  //     <svg
  //       width="25"
  //       viewBox="0 0 33 23"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M1.98301 17.844H31.0187C31.1826 17.844 31.3187 17.7076 31.3187 17.544V0.299726C31.3187 0.217763 31.2884 0.156961 31.2459 0.109818C31.2402 0.102586 31.2359 0.0950866 31.2295 0.0886581C31.2231 0.0830331 31.2164 0.0790154 31.21 0.073926C31.1623 0.0310691 31.1015 0 31.0184 0H1.98274C1.81961 0 1.68274 0.13634 1.68274 0.299998V17.5442C1.68301 17.7076 1.81988 17.844 1.98301 17.844ZM2.68291 16.562V13.1145V3.73122V1.00395V1.00047H2.9588H9.23387H30.3181V2.06976V7.73249V16.8442H2.65997C2.67416 16.7764 2.68327 16.6864 2.68327 16.5624L2.68291 16.562Z"
  //         fill="white"
  //       />
  //       <path
  //         d="M32.7001 18.4446H0.300262C0.218299 18.4446 0.157765 18.4749 0.110355 18.5178C0.102855 18.5234 0.0956234 18.5274 0.0886586 18.5338C0.0830336 18.5403 0.0790159 18.547 0.0739265 18.5539C0.0310697 18.6011 0 18.6624 0 18.7452C0 21.7068 3.34441 22.0417 5.61905 22.0417H16.4999H27.1819C29.4975 22.0417 33 21.8059 33 18.7452C33.0003 18.5805 32.8634 18.4446 32.7003 18.4446L32.7001 18.4446ZM32.091 19.7451C31.9434 19.8292 31.7494 19.9283 31.4974 20.0478C30.8575 20.8267 29.6238 20.989 28.7058 21.041H14.9127H6.48742H4.50339C4.04107 21.041 3.74266 21.0136 3.18182 20.9159C2.78432 20.8468 0.548284 19.4443 0.875025 19.4443H31.0799H32.0551H32.2183C32.1853 19.5469 32.1422 19.647 32.091 19.7451L32.091 19.7451Z"
  //         fill="white"
  //       />
  //       <path
  //         d="M14.8401 2.68427H18.1612C18.3252 2.68427 18.4612 2.54793 18.4612 2.38428V1.98437C18.4612 1.82071 18.3252 1.68437 18.1612 1.68437H14.8401C14.7576 1.68437 14.6968 1.71517 14.6494 1.75803C14.6421 1.76312 14.6354 1.76767 14.6285 1.77357C14.6226 1.77999 14.6186 1.78723 14.6132 1.79392C14.5709 1.8416 14.5396 1.9024 14.5396 1.98463V2.38454C14.5401 2.54793 14.6759 2.68427 14.8401 2.68427Z"
  //         fill="white"
  //       />
  //       <path
  //         d="M24.3529 5.80975C23.7248 5.11897 23.0964 4.42866 22.4694 3.73788C22.3552 3.61279 22.1613 3.63181 22.0451 3.73788C19.9215 5.66829 17.7982 7.59877 15.6747 9.52945C15.2306 9.93311 14.7862 10.337 14.3424 10.7401C14.2907 10.7873 14.254 10.8269 14.2242 10.8628C14.2114 10.8476 14.1966 10.832 14.1774 10.8157C13.0931 9.88298 12.0085 8.9498 10.9245 8.01689C10.808 7.91698 10.6124 7.88618 10.5002 8.01689C9.8919 8.72454 9.28251 9.43199 8.67422 10.1394C8.57431 10.2559 8.54378 10.4514 8.67422 10.5636C10.471 12.1097 12.2678 13.6552 14.0651 15.2016C14.1934 15.3119 14.361 15.3181 14.4893 15.2016C17.7773 12.2123 21.0644 9.22329 24.3526 6.23387C24.4699 6.12673 24.4643 5.99467 24.4011 5.89155C24.3885 5.86316 24.3756 5.83557 24.3526 5.80959L24.3529 5.80975ZM21.9087 7.10458C19.4704 9.32189 17.0316 11.5387 14.5922 13.7557C14.4103 13.9212 14.3059 13.9997 14.2485 14.0434C13.8178 13.6729 13.3869 13.3017 12.9561 12.9315C11.9281 12.0468 10.8998 11.1623 9.87179 10.2776C10.1686 9.93231 10.4653 9.58735 10.7629 9.2423C10.7726 9.23078 10.7745 9.22355 10.7833 9.21257C10.9218 9.33176 11.0597 9.45069 11.1985 9.56988C12.1392 10.3791 13.0796 11.1883 14.0203 11.998C14.1486 12.1083 14.3168 12.1145 14.4446 11.998C16.559 10.0761 18.6738 8.15396 20.7877 6.23157C21.2296 5.82952 21.6721 5.42744 22.1141 5.02568C22.1452 4.99756 22.1757 4.9697 22.206 4.94157C22.214 4.94747 22.2191 4.95229 22.228 4.95872C22.382 5.12827 22.536 5.29782 22.6903 5.46711C22.8443 5.6364 22.9975 5.80541 23.151 5.97469C22.738 6.3513 22.3239 6.72819 21.9087 7.10458Z"
  //         fill="white"
  //       />
  //     </svg>
  //   ),
  //   url: "/finish",
  // },
];
